import img1 from 'assets/images/aboutUsPage/productionTablet/1.png'
import img2 from 'assets/images/aboutUsPage/productionTablet/2.png'
import img3 from 'assets/images/aboutUsPage/productionTablet/3.png'

export const ProductionItemsTitle = '#Смело\n#честно\n#необычно'

export const ProductionItems = [
  {
    title: 'Создание',
    descr:
      'Разрабатываем идеи для создания оригинального контента. Привлекаем к сотрудничеству авторов сценария и продюсеров.',
    img: img1,
    video: '',
  },
  {
    title: 'Производство',
    descr:
      'Продюсируем, инвестируем в производство и снимаем сериалы, фильмы и документалистику нового поколения.',
    img: img2,
    video: '',
  },
  {
    title: 'Дистрибуция',
    descr:
      'Привлекаем клиентов используя собственные ресурсы доставки контента,\nа также через широкую сеть внешних партнерств как в цифровом, так и оффлайн форматах.',
    img: img3,
    video: '',
  },
]

export const ProductionItemsDesktop = [
  {
    title: ProductionItemsTitle,
    descr: '',
    img: img2,
    video: '',
  },
  ...ProductionItems,
]
